let currentSection = 1;
var totalSections = sectionsConfig.length; // Use the length of the sectionsConfig array
let capturedImages = {
    Front: '',
    Back: '',
    Right: '',
    Left: ''
};
const blockedCharsRegex = /[&<>"'/`();]/g;

function showSection(section) {
    for (let i = 0; i < totalSections; i++) {
        document.getElementById(sectionsConfig[i].id).style.display = 'none';
    }
    document.getElementById('tent-setup-button').style.display = 'inline-block';

    document.getElementById(sectionsConfig[section - 1].id).style.display = 'inline';
    updateCurrentSectionText(section);
    updateButtonVisibility(section);
    currentSection = section;
    const fullSection = sectionsConfig[section - 1];
    let part;
    if(fullSection.title.includes("Peak")){
        part = "Peak";
    }
    else if(fullSection.title.includes("Valance")){
        part = "Valance";
    }
    else{
        part = "Wall";
    }

    const tabButtons = document.querySelectorAll('.tab-button2');
    tabButtons.forEach(button => button.classList.remove('active'));
    document.querySelector(`.tab-button2[onclick="switchPart('${part}')"]`).classList.add('active');

    const allCanvases = document.querySelectorAll('#tent-canvases .canvas2');
    const allTextCanvases = document.querySelectorAll('#tent-canvases .text-overlay');
    const overlayImage = document.getElementById('ValanceLogo');
    const previewer = document.getElementById('tentPreviewCanvas');
    const previewImage = document.getElementById('tentPreviewImage');

    allCanvases.forEach(canvas => {
        canvas.style.display = 'none';
    });

    allTextCanvases.forEach(canvas => {
        canvas.style.display = 'none';
    });

    overlayImage.style.display = 'none';
    previewer.style.display = 'none';
    previewImage.style.display = 'none';

    // Remove any existing overlays
    document.querySelectorAll('.canvas-overlay').forEach(overlay => overlay.remove());

    const sectionTitle = sectionsConfig[section - 1].title;
    if(itType){
        switch (sectionTitle) {
            case "Front Peak":
                showCanvasWithOverlay('FrontPeakCanvas', 'FrontValanceCanvas', 'FrontPeakTextOverlay', 'FrontValanceTextOverlay');
                overlayImage.style.display = 'block';
                updateOverlayPositionAndSize("Front Peak");
                updateOverlayPositionAndSize("Front Valance");
                break;
            case "Front Valance":
                showCanvasWithOverlay('FrontValanceCanvas', 'FrontPeakCanvas', 'FrontPeakTextOverlay', 'FrontValanceTextOverlay');
                overlayImage.style.display = 'block';
                updateOverlayPositionAndSize("Front Peak");
                updateOverlayPositionAndSize("Front Valance");
                break;
            case "Back Peak":
                showCanvasWithOverlay('BackPeakCanvas', 'BackValanceCanvas', 'BackWallCanvas', 'BackPeakTextOverlay', 'BackValanceTextOverlay', 'BackWallTextOverlay');
                updateOverlayPositionAndSize("Back Peak");
                updateOverlayPositionAndSize("Back Valance");
                updateOverlayPositionAndSize("Back Wall");
                break;
            case "Back Valance":
                showCanvasWithOverlay('BackValanceCanvas', 'BackPeakCanvas', 'BackWallCanvas', 'BackPeakTextOverlay', 'BackValanceTextOverlay', 'BackWallTextOverlay');
                updateOverlayPositionAndSize("Back Peak");
                updateOverlayPositionAndSize("Back Valance");
                updateOverlayPositionAndSize("Back Wall");
                break;
            case "Back Wall":
                showCanvasWithOverlay('BackWallCanvas', 'BackPeakCanvas', 'BackValanceCanvas', 'BackPeakTextOverlay', 'BackValanceTextOverlay', 'BackWallTextOverlay');
                updateOverlayPositionAndSize("Back Peak");
                updateOverlayPositionAndSize("Back Valance");
                updateOverlayPositionAndSize("Back Wall");
                break;
            case "Right Peak":
                showCanvasWithOverlay('RightPeakCanvas', 'RightValanceCanvas', 'RightWallCanvas', 'RightPeakTextOverlay', 'RightValanceTextOverlay', 'RightWallTextOverlay');
                updateOverlayPositionAndSize("Right Peak");
                updateOverlayPositionAndSize("Right Valance");
                updateOverlayPositionAndSize("Right Wall");
                break;
            case "Right Valance":
                showCanvasWithOverlay('RightValanceCanvas', 'RightPeakCanvas', 'RightWallCanvas', 'RightPeakTextOverlay', 'RightValanceTextOverlay', 'RightWallTextOverlay');
                updateOverlayPositionAndSize("Right Peak");
                updateOverlayPositionAndSize("Right Valance");
                updateOverlayPositionAndSize("Right Wall");
                break;
            case "Right Wall":
                showCanvasWithOverlay('RightWallCanvas', 'RightPeakCanvas', 'RightValanceCanvas', 'RightPeakTextOverlay', 'RightValanceTextOverlay', 'RightWallTextOverlay');
                updateOverlayPositionAndSize("Right Peak");
                updateOverlayPositionAndSize("Right Valance");
                updateOverlayPositionAndSize("Right Wall");
                break;
            case "Left Peak":
                showCanvasWithOverlay('LeftPeakCanvas', 'LeftValanceCanvas', 'LeftWallCanvas', 'LeftPeakTextOverlay', 'LeftValanceTextOverlay', 'LeftWallTextOverlay');
                updateOverlayPositionAndSize("Left Peak");
                updateOverlayPositionAndSize("Left Valance");
                updateOverlayPositionAndSize("Left Wall");
                break;
            case "Left Valance":
                showCanvasWithOverlay('LeftValanceCanvas', 'LeftPeakCanvas', 'LeftWallCanvas', 'LeftPeakTextOverlay', 'LeftValanceTextOverlay', 'LeftWallTextOverlay');
                updateOverlayPositionAndSize("Left Peak");
                updateOverlayPositionAndSize("Left Valance");
                updateOverlayPositionAndSize("Left Wall");
                break;
            case "Left Wall":
                showCanvasWithOverlay('LeftWallCanvas', 'LeftPeakCanvas', 'LeftValanceCanvas', 'LeftPeakTextOverlay', 'LeftValanceTextOverlay', 'LeftWallTextOverlay');
                updateOverlayPositionAndSize("Left Peak");
                updateOverlayPositionAndSize("Left Valance");
                updateOverlayPositionAndSize("Left Wall");
                break;
        }
    }
    else{
        switch (sectionTitle) {
            case "Front Peak":
                showCanvasWithOverlay('FrontPeakCanvas', 'FrontValanceCanvas', 'FrontPeakTextOverlay', 'FrontValanceTextOverlay');
                overlayImage.style.display = 'block';
                updateOverlayPositionAndSize("Front Peak");
                updateOverlayPositionAndSize("Front Valance");
                break;
            case "Front Valance":
                showCanvasWithOverlay('FrontValanceCanvas', 'FrontPeakCanvas', 'FrontPeakTextOverlay', 'FrontValanceTextOverlay');
                overlayImage.style.display = 'block';
                updateOverlayPositionAndSize("Front Peak");
                updateOverlayPositionAndSize("Front Valance");
                break;
            case "Back Peak":
                showCanvasWithOverlay('BackPeakCanvas', 'BackValanceCanvas', 'BackPeakTextOverlay', 'BackValanceTextOverlay');
                updateOverlayPositionAndSize("Back Peak");
                updateOverlayPositionAndSize("Back Valance");
                break;
            case "Back Valance":
                showCanvasWithOverlay('BackValanceCanvas', 'BackPeakCanvas', 'BackPeakTextOverlay', 'BackValanceTextOverlay');
                updateOverlayPositionAndSize("Back Peak");
                updateOverlayPositionAndSize("Back Valance");
                break;
            case "Right Peak":
                showCanvasWithOverlay('RightPeakCanvas', 'RightValanceCanvas', 'RightPeakTextOverlay', 'RightValanceTextOverlay');
                updateOverlayPositionAndSize("Right Peak");
                updateOverlayPositionAndSize("Right Valance");
                break;
            case "Right Valance":
                showCanvasWithOverlay('RightValanceCanvas', 'RightPeakCanvas', 'RightPeakTextOverlay', 'RightValanceTextOverlay');
                updateOverlayPositionAndSize("Right Peak");
                updateOverlayPositionAndSize("Right Valance");
                break;
            case "Left Peak":
                showCanvasWithOverlay('LeftPeakCanvas', 'LeftValanceCanvas', 'LeftPeakTextOverlay', 'LeftValanceTextOverlay');
                updateOverlayPositionAndSize("Left Peak");
                updateOverlayPositionAndSize("Left Valance");
                break;
            case "Left Valance":
                showCanvasWithOverlay('LeftValanceCanvas', 'LeftPeakCanvas', 'LeftPeakTextOverlay', 'LeftValanceTextOverlay');
                updateOverlayPositionAndSize("Left Peak");
                updateOverlayPositionAndSize("Left Valance");
                break;
        }
    }
}

function nextSection() {
    const curSection = sectionsConfig[currentSection - 1]
    const currentSectionId = sectionsConfig[currentSection - 1].id;

    // Validate the current section's input
    if (!validateTextInput(currentSectionId)) {
        showRequiredFieldsModal();
        return; // Prevent moving to the next section if validation fails
    }

    let tab = '';

    if (currentSection < totalSections) {
        currentSection++;
        showSection(currentSection);
        if(sectionChange(curSection)){
            tab = nextTab(currentTab);
            switchTab(tab);
        }
        updateOverlayPositionAndSize(sectionsConfig[currentSection-1].title);
    } else {
        previewNow();
        switchTab('tent-submission');
    }
}

function prevSection() {
    const curSection = sectionsConfig[currentSection - 1];
    const currentSectionId = curSection.id;
    const currentSectionTitle = curSection.title;

    let tab = '';

    if (currentSection > 1) {
        currentSection--;
        if(sectionChange(curSection)){
            tab = prevTab(currentTab);
            switchTab(tab);
        }
        showSection(currentSection);
    }
}

function updateCurrentSectionText(section) {
    const currentSectionSpan = document.getElementById('current-section');
    const sectionTitle = sectionsConfig[section - 1].title; // Get the title from the config
    currentSectionSpan.textContent = sectionTitle;
}

function updateButtonVisibility(section) {
    sectionsConfig.forEach((_, index) => {
        const prevButton = document.getElementById(`prevButton-${sectionsConfig[index].id}`);
        const nextButton = document.getElementById(`nextButton-${sectionsConfig[index].id}`);
        
        if (index + 1 === section) {
            if (section === 1) {
                prevButton.style.visibility = 'hidden';
            } else {
                prevButton.style.visibility = 'visible';
            }
    
            if (section === totalSections) {
                nextButton.style.visibility = 'visible';
                nextButton.textContent = 'Preview Now!'
            } else {
                nextButton.style.visibility = 'visible';
            }
        } else {
            prevButton.style.visibility = 'hidden';
            nextButton.style.visibility = 'hidden';
        }
    });
}

// Custom dropdown functions
function toggleDropdown(id) {
    // Close any open dropdowns
    const dropdowns = document.getElementsByClassName("custom-dropdown-content");
    for (let i = 0; i < dropdowns.length; i++) {
        if (dropdowns[i].id !== id && dropdowns[i].classList.contains('show')) {
            dropdowns[i].classList.remove('show');
        }
    }
    // Toggle the clicked dropdown
    document.getElementById(id).classList.toggle("show");
}

function selectDropdownOption(dropdownId, value, sectionId) {
    const button = document.querySelector(`#${dropdownId}`).previousElementSibling;
    button.value = value;
    button.style.color = 'black'; // Set the text color of the button to black when a selection is made

    // Map custom font names to their CSS classes
    const fontClassMap = {
        'Benguiat BK': 'benguiat-bk',
        'Cityd Bold': 'cityd-bold',
        'Demonized': 'demonized',
        'Deadknight': 'Deadknight',
        'Eurostile': 'eurostile',
        'Evogria': 'evogria',
        'Evogria Italic': 'evogria-italic',
        'Famous College': 'Famous-College',
        'Keylock Fighter': 'Keylock-Fighter',
        'Magnolia Script': 'magnolia-script',
        'Rock Road': 'Rock-Road',
        'Srabi Script': 'srabi-script',
        'Steel City': 'Steel-City',
        'Superstar': 'superstar-m54',
        'SwitzerlandCond Italic': 'swzconbi',
        'SwitzerlandCond': 'swzconbn',
    };

    if (dropdownId.includes('font-style') && value != '') {
        button.style.fontFamily = fontClassMap[value]; // Set the font family of the button text to match the chosen font style
    }
    else{
        button.style.fontFamily = 'Arial';
    }

    if(value == ''){
        value = 'Select a Font Style'
    }
    button.innerHTML = `${value} <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>`;

    document.getElementById(dropdownId).classList.remove("show");

    // Update the canvas text when an option is selected
    const section = sectionsConfig.find(section => section.id === sectionId);
    updateCanvasText(section);
}

function selectColorPickerOption(labelId, colorValue, sectionId) {
    const label = document.getElementById(labelId);
    if (colorValue == null){
        label.textContent = "None";
    }
    else{
        label.textContent = colorValue;  
    }

    const section = sectionsConfig.find(section => section.id === sectionId);
    updateCanvasText(section);
}

function handleFileDrop(event, sectionId, sectionTitle) {
    event.preventDefault();
    const files = event.dataTransfer.files;

    if (files.length > 0) {
        const fileInput = document.getElementById(`upload-${sectionId}`);

        // Create a new DataTransfer object to update the input files
        const dataTransfer = new DataTransfer();
        for (const file of files) {
            dataTransfer.items.add(file);
        }
        fileInput.files = dataTransfer.files;

        // Call the existing functions to process the files
        validateFileInput({ target: fileInput }, sectionId);
        addArt(sectionId, sectionTitle);
    }
}

function showUploadModal() {
    const modal = document.getElementById('file-upload-modal');
    modal.style.display = 'block';
}

function closeUploadModal() {
    const modal = document.getElementById('file-upload-modal');
    modal.style.display = 'none';
}

function showRequiredFieldsModal() {
    const modal = document.getElementById('required-fields-modal');
    modal.style.display = 'block';
}

function closeRequiredFieldsModal() {
    const modal = document.getElementById('required-fields-modal');
    modal.style.display = 'none';
}

document.getElementById('horizontalCenter').addEventListener('click', () => {
    const selectedTextBox = document.querySelector('.editable-text.selected, .editable-text.selected2, .editable-art.selected, .editable-art.selected2');
    if (selectedTextBox) {
        const textOverlay = selectedTextBox.closest('.text-overlay');
        if (textOverlay) {
            selectedTextBox.style.left = `${(textOverlay.offsetWidth - selectedTextBox.offsetWidth) / 2}px`;
        }
    }
});

document.getElementById('verticalCenter').addEventListener('click', () => {
    const selectedTextBox = document.querySelector('.editable-text.selected, .editable-text.selected2, .editable-art.selected, .editable-art.selected2');
    if (selectedTextBox) {
        const textOverlay = selectedTextBox.closest('.text-overlay');
        if (textOverlay) {
            selectedTextBox.style.top = `${(textOverlay.offsetHeight - selectedTextBox.offsetHeight) / 2}px`;
        }
    }
});

// Close the modal when clicking outside of it
window.onclick = function(event) {
    const modal = document.getElementById('file-upload-modal');
    if (event.target == modal) {
        modal.style.display = 'none';
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const snapButton = document.getElementById('toggleSnapGrid');
    const horizButton = document.getElementById('horizontalCenter');
    const vertButton = document.getElementById('verticalCenter');

    snapButton.addEventListener('mouseover', function() {
        this.querySelector('img').src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
    });

    snapButton.addEventListener('mouseout', function() {
        const img = this.querySelector('img');
        if (this.classList.contains('active')) {
            img.src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
        } else {
            img.src = `${window.shopifyAssetPaths.grid.snapGrid}`;
        }
    });

    horizButton.addEventListener('mouseover', function() {
        this.querySelector('img').src = `${window.shopifyAssetPaths.grid.horizontalCenterWhite}`;
    });
    horizButton.addEventListener('mouseout', function() {
        this.querySelector('img').src = `${window.shopifyAssetPaths.grid.horizontalCenter}`;
    });

    vertButton.addEventListener('mouseover', function() {
        this.querySelector('img').src = `${window.shopifyAssetPaths.grid.verticalCenterWhite}`;
    });
    vertButton.addEventListener('mouseout', function() {
        this.querySelector('img').src = `${window.shopifyAssetPaths.grid.verticalCenter}`;
    });

    snapButton.addEventListener('click', function() {
        this.classList.toggle('active');
        const img = this.querySelector('img');
        if (this.classList.contains('active')) {
            img.src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
        } else {
            img.src = `${window.shopifyAssetPaths.grid.snapGrid}`;
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    generateSections(sectionsConfig);
    showSection(currentSection); // Ensure this is called
    initializeAllCanvases(); // Initialize all canvases

    const blockedCharsRegex = /[&<>"'/`();]/g;
    const maxLength = 200;

    sectionsConfig.forEach(section => {
        const textInput = document.getElementById(`text-input-${section.id}`);
        textInput.addEventListener('input', () => {
            cleanInput(textInput, blockedCharsRegex);
            validateTextInput(section.id);
            updateCanvasText(section);
        });
        textInput.addEventListener('paste', () => {
            cleanInput(textInput, blockedCharsRegex);
            updateCanvasText(section);
        });
        

        const fontStyleDropdown = document.querySelector(`#font-style-${section.id}`).parentElement;
        fontStyleDropdown.addEventListener('click', () => validateTextInput(section.id));

        const notesInput = document.getElementById(`notes-${section.id}`);
        notesInput.addEventListener('input', (event) =>{
          cleanInput(notesInput, blockedCharsRegex);
          enforceCharacterLimit(event, maxLength);  
        });
    });

    const emailAddr = document.getElementById('email');
    emailAddr.addEventListener('input', () => cleanInput(emailAddr, blockedCharsRegex));

    const emailConfirmAddr = document.getElementById('confirmEmail');
    emailConfirmAddr.addEventListener('input', () => cleanInput(emailConfirmAddr, blockedCharsRegex));

    const userName = document.getElementById('userName');
    userName.addEventListener('input', () => cleanInput(userName, blockedCharsRegex));

    const schoolClub = document.getElementById('schoolClub');
    schoolClub.addEventListener('input', () => cleanInput(schoolClub, blockedCharsRegex));

    const salesRep = document.getElementById('salesRep');
    salesRep.addEventListener('input', () => cleanInput(schoolClub, blockedCharsRegex));

    const street = document.getElementById('street');
    street.addEventListener('input', () => cleanInput(street, blockedCharsRegex));

    const city = document.getElementById('city');
    city.addEventListener('input', () => cleanInput(city, blockedCharsRegex));

    const tentName = document.getElementById('Tent-Name');
    tentName.addEventListener('input', () => cleanInput(tentName, blockedCharsRegex));

    // Add event listener to form submission
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', sanitizeFormInputs);
    }
    document.addEventListener('DOMContentLoaded', updateTentPricing);

});

function bindSectionEventListeners() {
    const blockedCharsRegex = /[&<>"'/`();]/g;
    const maxLength = 200;

    sectionsConfig.forEach(section => {
        const textInput = document.getElementById(`text-input-${section.id}`);
        textInput.addEventListener('input', () => {
            cleanInput(textInput, blockedCharsRegex);
            validateTextInput(section.id);
            updateCanvasText(section);
        });
        textInput.addEventListener('paste', () => {
            cleanInput(textInput, blockedCharsRegex);
            updateCanvasText(section);
        });
        

        const fontStyleDropdown = document.querySelector(`#font-style-${section.id}`).parentElement;
        fontStyleDropdown.addEventListener('click', () => validateTextInput(section.id));

        const notesInput = document.getElementById(`notes-${section.id}`);
        notesInput.addEventListener('input', (event) =>{
          cleanInput(notesInput, blockedCharsRegex);
          enforceCharacterLimit(event, maxLength);  
        });
    });

    const emailAddr = document.getElementById('email');
    emailAddr.addEventListener('input', () => cleanInput(emailAddr, blockedCharsRegex));

    const emailConfirmAddr = document.getElementById('confirmEmail');
    emailConfirmAddr.addEventListener('input', () => cleanInput(emailConfirmAddr, blockedCharsRegex));

    const userName = document.getElementById('userName');
    userName.addEventListener('input', () => cleanInput(userName, blockedCharsRegex));

    const schoolClub = document.getElementById('schoolClub');
    schoolClub.addEventListener('input', () => cleanInput(schoolClub, blockedCharsRegex));

    const salesRep = document.getElementById('salesRep');
    salesRep.addEventListener('input', () => cleanInput(schoolClub, blockedCharsRegex));

    const street = document.getElementById('street');
    street.addEventListener('input', () => cleanInput(street, blockedCharsRegex));

    const city = document.getElementById('city');
    city.addEventListener('input', () => cleanInput(city, blockedCharsRegex));

    const tentName = document.getElementById('Tent-Name');
    tentName.addEventListener('input', () => cleanInput(tentName, blockedCharsRegex));

    // Add event listener to form submission
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', sanitizeFormInputs);
    }
}
  

function copyOppositeSection(sectionId) {
    let sourceSection, targetSection;

    // Map the button clicked to the corresponding source and target sections
    switch(sectionId) {
        case 'back-peak':
            sourceSection = getSectionIdByTitle('Front Peak');
            targetSection = getSectionIdByTitle('Back Peak');
            break;
        case 'back-valance':
            sourceSection = getSectionIdByTitle('Front Valance');
            targetSection = getSectionIdByTitle('Back Valance');
            break;
        case 'left-peak':
            sourceSection = getSectionIdByTitle('Right Peak');
            targetSection = getSectionIdByTitle('Left Peak');
            break;
        case 'left-valance':
            sourceSection = getSectionIdByTitle('Right Valance');
            targetSection = getSectionIdByTitle('Left Valance');
            break;
        case 'left-wall':
            sourceSection = getSectionIdByTitle('Right Wall');
            targetSection = getSectionIdByTitle('Left Wall');
            break;
    }

    // Now, copy the relevant properties
    copyTentCanvasColor(sourceSection.title.replace(' ', ''), targetSection.title.replace(' ',''), sourceSection, targetSection);
    copyTextProperties(sourceSection, targetSection);
    copyArtElements(sourceSection, targetSection);
    copyNotes(sourceSection, targetSection);
}

// Copy the tent canvas color from the source to target section
function copyTentCanvasColor(sourceTitle, targetTitle, source, target) {
    document.getElementById(`selected-color-${target.id}`).innerText = document.getElementById(`selected-color-${source.id}`).innerText;

    const sourceCanvas = document.getElementById(`${sourceTitle}Canvas`);
    const targetCanvas = document.getElementById(`${targetTitle}Canvas`);
    const contextSrc = sourceCanvas.getContext('2d');
    const contextTarget = targetCanvas.getContext('2d');
    contextTarget.fillStyle = contextSrc.fillStyle;
    contextTarget.fill();
    contextTarget.strokeStyle = '#5A5A5A';
    contextTarget.stroke();

    // Find the selected radio button in the source section
    const sourceRadios = document.querySelectorAll(`input[name="color-${source.id}"]`);
    const selectedSourceRadio = Array.from(sourceRadios).find(radio => radio.checked);

    if (selectedSourceRadio) {
        // Copy Radio Button Color
        const targetRadios = document.querySelectorAll(`input[name="color-${target.id}"]`);
        targetRadios.forEach(radio => {
            radio.checked = radio.value === selectedSourceRadio.value;
        });
    }
    else{
        //Copy Custom Color
        const targetRadios = document.querySelectorAll(`input[name="color-${target.id}"]`);
        targetRadios.forEach(radio => {
            radio.checked = false;
        });

        const sourcePickr = pickrInstances[source.name];
        const targetPickr = pickrInstances[target.name];
        
        if (sourcePickr && targetPickr) {
            // Get the current color from the source Pickr instance
            const sourceColor = sourcePickr.getColor().toHEXA().toString();
            
            // Set the color in the target Pickr instance
            targetPickr.setColor(sourceColor);
        } else {
            console.error("Pickr instances not found for source or target sections.");
        }
    }
}

// Copy text properties (font, color, outline, size, and position)
function copyTextProperties(source, target) {
    const sourceInput = document.getElementById(`text-input-${source.id}`);
    const targetInput = document.getElementById(`text-input-${target.id}`);

    if (!sourceInput || !targetInput) return;

    // Copy raw text
    targetInput.value = sourceInput.value;

    // Copy font style
    const sourceFontButton = document.querySelector(`#font-style-${source.id}`).previousElementSibling;
    const sourceFontStyle = sourceFontButton?.value || '';
    selectDropdownOption(`font-style-${target.id}`, sourceFontStyle, target.id);

    // Copy font color
    const sourceFontLabel = document.getElementById(`font-color-${source.id}`);
    const sourceFontColor = sourceFontLabel?.textContent?.trim() || '#000000';
    const targetFontPickr = pickrInstances2[target.name];

    if (targetFontPickr) {
        targetFontPickr.setColor(sourceFontColor);
        selectColorPickerOption(`font-color-${target.id}`, sourceFontColor, target.id);
    }

    // Copy outline color
    const sourceOutlineLabel = document.getElementById(`outline-color-${source.id}`);
    const sourceOutlineText = sourceOutlineLabel?.textContent?.trim() || 'None';
    const targetOutlinePickr = pickrInstances3[target.name];

    if (targetOutlinePickr) {
        if (
            !sourceOutlineText ||
            sourceOutlineText.toLowerCase() === 'none' ||
            sourceOutlineText === ''
        ) {
            targetOutlinePickr.setColor(null);
            selectColorPickerOption(`outline-color-${target.id}`, null, target.id);
        } else {
            targetOutlinePickr.setColor(sourceOutlineText);
            selectColorPickerOption(`outline-color-${target.id}`, sourceOutlineText, target.id);
        }
    }

    // Build/update target text element using your current system
    updateCanvasText(target);

    const sourceTextElement = document.getElementById(`editable-text-${source.id}`);
    const targetTextElement = document.getElementById(`editable-text-${target.id}`);

    if (sourceTextElement && targetTextElement) {
        const sourceStyles = window.getComputedStyle(sourceTextElement);

        // Copy box placement/sizing/font state
        targetTextElement.style.left = sourceTextElement.style.left;
        targetTextElement.style.top = sourceTextElement.style.top;
        targetTextElement.style.width = sourceStyles.width;
        targetTextElement.style.height = sourceStyles.height;
        targetTextElement.style.fontSize = sourceStyles.fontSize;
        targetTextElement.style.paddingTop = sourceStyles.paddingTop;
        targetTextElement.style.paddingRight = sourceStyles.paddingRight;
        targetTextElement.style.paddingBottom = sourceStyles.paddingBottom;
        targetTextElement.style.paddingLeft = sourceStyles.paddingLeft;

        // Copy rotation
        const sourceRotation = sourceTextElement.dataset.rotation || '0';
        targetTextElement.dataset.rotation = sourceRotation;
        targetTextElement.style.transform = `rotate(${sourceRotation}deg)`;

        // Copy resize baseline so future resizing behaves the same
        if (sourceTextElement.dataset.baseWidth) {
            targetTextElement.dataset.baseWidth = sourceTextElement.dataset.baseWidth;
        }
        if (sourceTextElement.dataset.baseHeight) {
            targetTextElement.dataset.baseHeight = sourceTextElement.dataset.baseHeight;
        }
        if (sourceTextElement.dataset.baseFontSize) {
            targetTextElement.dataset.baseFontSize = sourceTextElement.dataset.baseFontSize;
        }

        // Copy actual content as plain text into the text-content node
        const sourceTextContent = sourceTextElement.querySelector('.text-content');
        const targetTextContent = targetTextElement.querySelector('.text-content');

        if (sourceTextContent && targetTextContent) {
            targetTextContent.innerText = sourceTextContent.innerText.replace(/\r/g, '');
        }
    }

    validateTextInput(target.id);
}

// Copy art elements (placement, size, preview)
function copyArtElements(source, target) {
    const sourceArtPreview = document.getElementById(`art-preview-${source.id}`);
    const targetArtPreview = document.getElementById(`art-preview-${target.id}`);
    const sourceOverlay = document.getElementById(`${source.title.replace(' ', '')}TextOverlay`);
    const targetOverlay = document.getElementById(`${target.title.replace(' ', '')}TextOverlay`);

    if (!sourceArtPreview || !targetArtPreview || !sourceOverlay || !targetOverlay) {
        return;
    }

    const artIdMap = [];
    const targetSectionTitle = target.title.replace(' ', '');
    const targetCanvas = document.getElementById(`${targetSectionTitle}Canvas`);

    // Clear target preview
    targetArtPreview.innerHTML = '';

    // Remove existing overlay art from target
    targetOverlay.querySelectorAll('.editable-art').forEach(art => art.remove());

    // Copy preview cards first and generate fresh ids
    Array.from(sourceArtPreview.children).forEach((previewArt) => {
        const newArtId = `image-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        artIdMap.push(newArtId);

        const clonedPreview = previewArt.cloneNode(true);
        clonedPreview.id = `${newArtId}-preview`;

        // Update remove button
        const removeButton = clonedPreview.querySelector('.remove-art');
        if (removeButton) {
            removeButton.setAttribute('onclick', `removeArt('${newArtId}')`);
        }

        // Update dropdown button
        const dropdownButton = clonedPreview.querySelector('.custom-dropdown-button');
        if (dropdownButton) {
            dropdownButton.id = `selected-image-size-${newArtId}`;
            dropdownButton.setAttribute('onclick', `toggleDropdown('image-size-${newArtId}')`);
        }

        // Update dropdown content + options
        const dropdownContent = clonedPreview.querySelector('.custom-dropdown-content');
        if (dropdownContent) {
            dropdownContent.id = `image-size-${newArtId}`;

            dropdownContent.querySelectorAll('div').forEach(option => {
                const onclickValue = option.getAttribute('onclick') || '';
                const matches = onclickValue.match(/'([^']*)'/g) || [];
                const value = matches[1] ? matches[1].replace(/'/g, '') : '';
                const label = option.textContent.trim().replace(/'/g, "\\'");
                option.setAttribute(
                    'onclick',
                    `selectImageSizeOption('${newArtId}', '${value}', '${label}')`
                );
            });
        }

        targetArtPreview.appendChild(clonedPreview);
    });

    // Copy overlay art in same order
    const sourceOverlayArts = Array.from(sourceOverlay.querySelectorAll('.editable-art'));

    sourceOverlayArts.forEach((sourceArt, index) => {
        const newArtId = artIdMap[index] || `image-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        const clonedArt = sourceArt.cloneNode(true);

        clonedArt.id = newArtId;
        clonedArt.setAttribute('data-id', newArtId);
        clonedArt.classList.remove('selected', 'selected2');
        clonedArt.style.position = 'absolute';
        clonedArt.style.cursor = 'move';
        clonedArt.style.left = sourceArt.style.left;
        clonedArt.style.top = sourceArt.style.top;
        clonedArt.style.width = sourceArt.style.width;
        clonedArt.style.height = sourceArt.style.height;

        // Preserve rotation
        const rotation = sourceArt.dataset.rotation || '0';
        clonedArt.dataset.rotation = rotation;
        clonedArt.style.transform = `rotate(${rotation}deg)`;

        targetOverlay.appendChild(clonedArt);

        // Rebind behaviors for the new art system
        makeElementDraggable(clonedArt, targetOverlay);
        makeArtResizable(clonedArt);
        makeElementRotatable(clonedArt);
    });

    addSelectionListener(targetOverlay);

    // Show/hide label
    const artOrderLabel = document.getElementById(`art-order-label-${target.id}`);
    if (artOrderLabel) {
        artOrderLabel.style.display = targetArtPreview.children.length > 0 ? 'block' : 'none';
    }
}

// Copy notes
function copyNotes(source, target) {
    const sourceNotes = document.getElementById(`notes-${source.id}`).value;
    const targetNotes = document.getElementById(`notes-${target.id}`);
    document.getElementById(`char-count-${target.id}`).innerText = document.getElementById(`char-count-${source.id}`).innerText;
    targetNotes.value = sourceNotes;
}

function getSectionIdByTitle(title) {
    // Use the find method to search for the section with the matching title
    const section = sectionsConfig.find(section => section.title === title);
    
    // If a matching section is found, return its id, otherwise return null or a message
    return section ? section : null;
}

function switchTab(tabId) {
    if(tabId.includes("submission")){
        previewNow();
    }
    else{
        const currentSectionId = sectionsConfig[currentSection - 1].id;
        // Validate the current section's input
        if (!validateTextInput(currentSectionId)) {
            showRequiredFieldsModal();
            return; // Prevent moving to the next section if validation fails
        }
    }

    // Get all tab buttons and content sections
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    // Remove active class from all tabs and buttons
    tabButtons.forEach(button => button.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));

    // Add active class to the clicked tab and its content
    document.querySelector(`.tab-button[onclick="buttonSwitchTab('${tabId}')"]`).classList.add('active');
    document.getElementById(tabId).classList.add('active');
    currentTab = tabId;

    const fullSection = sectionsConfig[currentSection - 1];
    let part;
    if(fullSection.title.includes("Peak")){
        part = "Peak";
    }
    else if(fullSection.title.includes("Valance")){
        part = "Valance";
    }
    else{
        part = "Wall";
    }

    if(tabId.includes("submission")){
        document.getElementById("parts-container").style.display = 'none';
    }
    else if(tabId != 'tent-front' && itType){
        document.getElementById("parts-container").style.display = 'flex';
        document.querySelector(`.tab-button2[onclick="switchPart('Wall')"]`).style.display = 'block';
    }
    else{
        document.getElementById("parts-container").style.display = 'flex';
        document.querySelector(`.tab-button2[onclick="switchPart('Wall')"]`).style.display = 'none';
    }

    const tabButtons2 = document.querySelectorAll('.tab-button2');
    tabButtons2.forEach(button => button.classList.remove('active'));

    document.querySelector(`.tab-button2[onclick="switchPart('${part}')"]`).classList.add('active');
}

function switchPart(piece){
    const activePart = document.getElementById("parts-container").querySelector(".active").textContent;
    const currentSectionId = sectionsConfig[currentSection - 1].id;
    if (!validateTextInput(currentSectionId)) {
        showRequiredFieldsModal();
        return; // Prevent moving to the next section if validation fails
    }
    if(activePart == piece){
        return;
    }
    else if(activePart == "Peak"){
        if(piece == "Valance"){
            currentSection = currentSection + 1;
        }   
        else{
            currentSection = currentSection + 2;
        }
    }
    else if(activePart == "Valance"){
        if(piece == "Peak"){
            currentSection = currentSection - 1;
        }   
        else{
            currentSection = currentSection + 1;
        }
    }
    else if(activePart == "Wall"){
        if(piece == "Valance"){
            currentSection = currentSection - 1;
        }   
        else{
            currentSection = currentSection - 2;
        }
    }
    const tabButtons = document.querySelectorAll('.tab-button2');
    tabButtons.forEach(button => button.classList.remove('active'));

    document.querySelector(`.tab-button2[onclick="switchPart('${piece}')"]`).classList.add('active');
    showSection(currentSection);
    
}

function buttonSwitchTab(tabId) {
    if(tabId.includes("submission")){
        document.getElementById("parts-container").style.display = 'none';
        previewNow();
    }
    else{
        document.getElementById("parts-container").style.display = 'flex';
        const currentSectionId = sectionsConfig[currentSection - 1].id;
        // Validate the current section's input
        if (!validateTextInput(currentSectionId)) {
            showRequiredFieldsModal();
            return; // Prevent moving to the next section if validation fails
        }
        const tabButtons = document.querySelectorAll('.tab-button2');
        tabButtons.forEach(button => button.classList.remove('active'));
        document.querySelector(`.tab-button2[onclick="switchPart('Peak')"]`).classList.add('active');
        if(itType){
            if(tabId.includes("front")){
                currentSection = 1;
                showSection(currentSection);
            }
            else if(tabId.includes("back")){
                currentSection = 3;
                showSection(currentSection);
            }
            else if(tabId.includes("right")){
                currentSection = 6;
                showSection(currentSection);
            }
            else if(tabId.includes("left")){
                currentSection = 9;
                showSection(currentSection);
            }
            else{
            }
            if(tabId != 'tent-front'){
                document.querySelector(`.tab-button2[onclick="switchPart('Wall')"]`).style.display = 'block';
            }
            else{
                document.querySelector(`.tab-button2[onclick="switchPart('Wall')"]`).style.display = 'none';
            }
        }
        else{
            if(tabId.includes("front")){
                currentSection = 1;
                showSection(currentSection);
            }
            else if(tabId.includes("back")){
                currentSection = 3;
                showSection(currentSection);
            }
            else if(tabId.includes("right")){
                currentSection = 5;
                showSection(currentSection);
            }
            else if(tabId.includes("left")){
                currentSection = 7;
                showSection(currentSection);
            }
            else{
            }
        }
    }

    // Get all tab buttons and content sections
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    // Remove active class from all tabs and buttons
    tabButtons.forEach(button => button.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));

    // Add active class to the clicked tab and its content
    document.querySelector(`.tab-button[onclick="buttonSwitchTab('${tabId}')"]`).classList.add('active');
    document.getElementById(tabId).classList.add('active');
    currentTab = tabId;
}

function prevTab(tabId){
    let tab = '';
    if(tabId.includes("front")){
    }
    else if(tabId.includes("back")){
        tab = 'tent-front';
    }
    else if(tabId.includes("right")){
        tab = 'tent-back';
    }
    else if(tabId.includes("left")){
        tab = 'tent-right';
    }
    else{
        tab = 'tent-left';
    }
    return tab
}

function nextTab(tabId){
    let tab = '';
    if(tabId.includes("front")){
        tab = 'tent-back';
    }
    else if(tabId.includes("back")){
        tab = 'tent-right';
    }
    else if(tabId.includes("right")){
        tab = 'tent-left';
    }
    else if(tabId.includes("left")){
        tab = 'tent-submission';
    }
    else{

    }
    return tab
}
function sectionChange(curSection){
    let section1 = '';
    let section2 = '';
    if(curSection.title.includes("Front")){
        section1 = 'tent-front';
    }
    else if(curSection.title.includes("Back")){
        section1 = 'tent-back';
    }
    else if(curSection.title.includes("Right")){
        section1 = 'tent-right';
    }
    else{
        section1 = 'tent-left';
    }

    const newSection = sectionsConfig[currentSection - 1];
    if(newSection.title.includes("Front")){
        section2 = 'tent-front';
    }
    else if(newSection.title.includes("Back")){
        section2 = 'tent-back';
    }
    else if(newSection.title.includes("Right")){
        section2 = 'tent-right';
    }
    else{
        section2 = 'tent-left';
    }

    if(section1 != section2){
        return true;
    }
    else{
        return false;
    }
}

function getSelectedTentVariantId() {
  const key = `${itDescript}|${itType}|${onlyTop}`;
  const variantId = window.tentVariantMap[key];

  if (!variantId) {
    throw new Error(`No tent variant mapped for ${key}`);
  }

  return variantId;
}

function clearTabs(){
    tabs.forEach(tab => {
        document.getElementById(tab).innerHTML = '';
    });
    
}
const tabs = ["tent-front", "tent-back", "tent-right", "tent-left", "tent-submission"];
let currentTab = 'tent-front';
let onlyTop = 'false';